var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/folder-add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0801 22.0002V15.3335",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.3327 18.6665H12.666",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.3327 14.6665V22.6665C29.3327 27.9998 27.9993 29.3332 22.666 29.3332H9.33268C3.99935 29.3332 2.66602 27.9998 2.66602 22.6665V9.33317C2.66602 3.99984 3.99935 2.6665 9.33268 2.6665H11.3327C13.3327 2.6665 13.7727 3.25317 14.5327 4.2665L16.5327 6.93317C17.0393 7.59984 17.3327 7.99984 18.666 7.99984H22.666C27.9993 7.99984 29.3327 9.33317 29.3327 14.6665Z",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.23d7742ea62afba391feea297a4eea3d.svg";
export { ForwardRef as ReactComponent };